<template>
  <div class="py-4" :class="{ 'press container' : dataPrint.code}">
    <div v-if="dataPrint.code" id="section-to-print">
      <div v-if="dataPrint.voucher && dataPrint.voucher.id">
        <VoucherPoint :voucher="dataPrint.voucher" :meta="voucherMeta" :showqr="1" />
      </div>
      <div class="ticket-print text-center">
        <br>
        <div>
          <div style="margin: 20px auto;">
            FECHA DE EMISION: {{ dataPrint.date }}
          </div>
        </div>
        <br>
        <div>
          <div>Tipo de entrada</div>
          <div style="text-transform: uppercase;">
            {{ dataPrint.type }}
          </div>
        </div>
        <div style="font-weight: bold; font-size: 20px; line-height: 1.2">
          <div>{{ dataPrint.title }}</div>
          <small v-if="dataPrint.productName">{{ dataPrint.productName }}</small>
        </div>
        <br><br>
        <figure>
          <figcaption v-if="user.document" style="font-size: 15px;">
            <b>N° Doc: {{ user.document }}</b>
          </figcaption>
          <div>
            <img
              :src="'https://qr.joinnus.com/qr.png?size=180&body=' + dataPrint.code"
              style="display: inline-block;"
              alt="jn"
            >
          </div>
          <figcaption style="font-size: 18px; margin-bottom: 10px">
            <b>{{ dataPrint.code }}</b>
          </figcaption>
          <figcaption style="font-size: 25px">
            <b>{{ dataPrint.value ? 'S/ ' + dataPrint.value.toFixed(2) : 'Cortesía' }}</b>
          </figcaption>
        </figure>
        <p class="small">
          * Este documento no es un comprobante de pago.
        </p>
        <p class="small">
          * No hay devolución/reembolso de dinero.
        </p>
        <p>
          Para ver tus saldos y movimientos, ingresa a:
          <br><b><span style="font-size: 16px">miscompras.joinnus.com</span></b>
        </p>
        <div>
          <div style="margin: 20px auto;">
            FECHA DE EMISION: {{ dataPrint.date }}
          </div>
        </div>
      </div>
    </div>
    <div class="container no-print">
      <div v-show="!isProductsCourtesy" class="row justify-content-center">
        <div class="col-12 col-lg-10 col-xl-8">
          <div class="card shadow-sm">
            <div class="card-body py-sm-4 px-md-4">
              <div v-if="step === 1">
                <h2 class="mb-3 d-flex align-items-center" style="gap: 1rem;">
                  <button @click="goBack()" class="btn btn-outline-secondary">
                    Volver
                  </button>
                  <span class="title">Venta de puntos</span>
                </h2>
                <div class="card mb-4 bg-light">
                  <form @submit.prevent="onSearch()" class="card-body p-3">
                    <div class="row align-items-end">
                      <div class="col-12">
                        <h5>Buscar usuario:</h5>
                      </div>
                      <div class="col-12 col-sm-4">
                        <div class="form-group mb-3 mb-sm-0">
                          <select v-model="search.type" class="form-control">
                            <option value="code">Código QR</option>
                            <option value="document">Documento</option>
                            <option value="email">Email</option>
                          </select>
                        </div>
                      </div>
                      <div class="col">
                        <div v-if="showCamera && window.width < 768 && search.type === 'code'">
                          <qrcode-stream @decode="onDecode($event)" @init="onInit($event)" />
                          <p class="error">{{ error }}</p>
                        </div>
                        <div class="box-code" v-if="search.type === 'code'">
                          <input type="text"
                            placeholder="Inserta tu código QR"
                            class="form-control input"
                            v-model="search.value" maxlength="8"
                            required style="width: 100%">
                          <span
                            class="camera-icon"
                            @click="showCamera = true"
                            v-if="window.width < 768">
                            <img
                            src="/images/camera.png"
                            alt="actualizar"
                            style="width: 25px;"
                            >
                          </span>
                        </div>
                        <div class="form-group mb-0" v-else>
                          <input
                            v-model="search.value"
                            type="search"
                            class="form-control"
                            :maxlength="search.type === 'document' ? 15 : 50"
                            :placeholder="holderText"
                          >
                        </div>
                      </div>
                    </div>
                    <div v-if="loading" class="text-right mt-3">
                      <b-spinner label="Loading"></b-spinner>
                    </div>
                    <small v-if="!errors.userNotFound" class="text-danger mt-3">
                      {{ errors.userNotFound }}
                    </small>
                    <div v-if="searchData.length > 1" class="list-group mt-3">
                      <button
                        v-for="item in searchData"
                        :key="item.id || item.code"
                        @click="onSelectUser(item)"
                        type="button"
                        class="list-group-item text-left"
                      >
                        <span v-if="item.id">
                          {{ item.email }}
                          <span v-if="item.code">- QR: <b>{{ item.code }}</b> -</span>
                        </span>
                        <span v-else>Compró como invitado - QR: <b>{{ item.code }}</b> -</span>
                        <b v-if="item.code"> S/ {{ item.points }}</b>
                      </button>
                    </div>
                    <div v-if="userCode" class="list-group mt-3">
                      <button
                        @click="goStep(2)"
                        type="button"
                        class="list-group-item text-left"
                      >
                        <span>{{ userCode }}: </span>
                        <b>S/ {{ userCodeValue }}</b>
                      </button>
                    </div>
                  </form>
                </div>
                <form @submit.prevent="submitUser()">
                  <div class="row">
                    <div class="col-12 col-sm-6">
                      <div class="form-group">
                        <label>Tipo de documento</label>
                        <select v-model="user.documentType" class="form-control" required>
                          <option value="DNI">DNI</option>
                          <option value="CE">CE</option>
                          <option value="PASS">PASS</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6">
                      <div class="form-group">
                        <label>N° de documento</label>
                        <input
                          v-model="user.document"
                          type="text"
                          :maxlength="user.documentType === 'DNI' ? 8 : 15"
                          class="form-control"
                          required
                        >
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="form-group">
                        <label>Email</label>
                        <input v-model="user.email" type="email" class="form-control" required>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6">
                      <div class="form-group">
                        <label>Nombres</label>
                        <input v-model="user.firstName" type="text" class="form-control" required>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6">
                      <div class="form-group">
                        <label>Apellidos</label>
                        <input v-model="user.lastName" type="text" class="form-control" required>
                      </div>
                    </div>
                  </div>
                  <div v-if="autocompleteInfo" class="text-right text-success">
                    <b>Información autocompletada.</b>
                  </div>
                  <br>
                  <div class="btn-dev">
                    <div style="flex-basis: 100%;">
                      <button
                        @click="goQuest()"
                        type="button"
                        class="btn btn-outline-secondary w-100"
                      >
                        Usuario invitado
                      </button>
                    </div>
                    <div style="flex-basis: 100%;">
                      <button
                        :disabled="loadingUser"
                        type="submit"
                        class="btn btn-primary w-100"
                      >
                        <b-spinner v-if="loadingUser" small></b-spinner>
                        <span class="ml-2" style="vertical-align: middle;">Siguiente</span>
                      </button>
                    </div>
                  </div>
                  <hr class="d-none">
                  <div class="text-center d-none">
                    <button
                      @click="showProductsCourtesy()"
                      :disabled="loadingProducts"
                      type="button"
                      class="btn btn-outline-info btn-lg"
                    >
                      {{ loadingProducts ? 'Cargando...' : 'Productos de cortesía' }}
                    </button>
                    <div v-if="errorProducts" class="small text-danger">
                      Error el N° de documento es requerido.
                    </div>
                  </div>
                </form>
              </div>
              <div v-if="step === 2">
                <h2 class="mb-4 d-flex align-items-center title">
                  <button
                    @click="step = 1; resetUser()"
                    class="btn btn-outline-secondary btn-sm mr-4"
                  >
                    Anterior
                  </button>
                  <span>Recargar puntos</span>
                </h2>
                <div class="card mb-4 bg-light">
                  <div class="card-body p-3">
                    <div class="row justify-content-between align-items-center">
                      <div class="col">
                        <h5 class="mb-0">
                          <b>Usuario:</b> {{ userCode || user.email || user.document || 'Invitado' }}
                          <br>
                          <span v-if="user.points">Tiene: S/ <b>{{ user.points }}</b></span>
                        </h5>
                      </div>
                      <div class="col-auto">
                        <button
                          v-if="user.points" @click="printTransaction()"
                          type="button"
                          class="btn btn-primary btn-sm"
                        >
                          Imprimir actual
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mb-4">
                  <div class="input-group input-group-lg">
                    <div class="input-group-prepend">
                      <b class="input-group-text subtitle">
                        Monto a recargar: S/
                      </b>
                    </div>
                    <input
                      v-model="payment.amount"
                      type="number"
                      ref="amount"
                      class="form-control"
                    >
                  </div>
                </div>
                <h3 class="title">Forma de pago</h3>
                <div class="mb-4">
                  <PayMethods
                    v-model="formPay"
                    :pointsAmount="payment.amount"
                    :showYape="true"
                  >
                  </PayMethods>
                </div>
                <div class="col-12 my-4" v-if="formPay.type === 'efectivo'">
                  <table class="table w-100 ml-auto table-center">
                    <tbody>
                      <tr class="text-right">
                        <td class="border-0"><b>Efectivo recibido:</b></td>
                        <td class="border-0 h4">
                          <input
                          v-model="payment.cash"
                          type="number"
                          class="form-control"
                          placeholder="Efectivo Soles"
                          style="width: 160px; margin-left:auto"
                          >
                        </td>
                      </tr>
                      <tr class="text-right">
                        <td class="border-0"><b>Vuelto:</b></td>
                        <td class="border-0 h4">S/. {{ onChangeCash }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-if="errors.errorPayment" class="alert alert-danger text-center">
                  {{ errors.errorPayment }}
                </div>
                <div class="text-right">
                  <button
                    @click="onPayment()"
                    :disabled="formPay.type === 'pos' && !formPay.code
                      || payment.amount <= 0
                      || loading
                      || (formPay.type === 'efectivo' && !payment.cash)
                      || (formPay.type === 'efectivo'
                      && parseFloat(payment.amount) > parseFloat(payment.cash))"
                    type="button"
                    class="btn btn-action btn-lg"
                  >
                    Recargar
                  </button>
                </div>
              </div>
              <div v-if="step === 3">
                <div class="text-center p-3">
                  <h3>¡Recarga exitosa!</h3>
                  <hr>
                  <br>
                  <div style="width: 180px; margin: auto">
                    <button @click="printTransaction()" class="btn btn-action btn-lg btn-block">
                      Imprimir boleta
                    </button>
                    <hr>
                    <button @click="resetData()" class="btn btn-primary btn-lg btn-block">
                      Nueva recarga
                    </button>
                  </div>
                  <br>
                </div>
              </div>
              <div v-if="step === 4">
                <div class="text-center p-3">
                  <h3>¡Cortesía generada!</h3>
                  <hr>
                  <br>
                  <div style="width: 180px; margin: auto">
                    <button @click="printCourtesy()" class="btn btn-action btn-lg btn-block">
                      Imprimir Código
                    </button>
                    <hr>
                    <button @click="resetData()" class="btn btn-primary btn-lg btn-block">
                      Nueva cortesía
                    </button>
                  </div>
                  <br>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="isProductsCourtesy">
        <products-courtesy
          ref='appProductsCourtesy'
          @go-back="isProductsCourtesy = false; step = 1"
          @on-success="successCortesy($event)"
        ></products-courtesy>
      </div>
      <b-modal
        v-model="modals.confirm"
        hide-header
        hide-footer
      >
        <div class="my-3 text-center">
          <h5>
            Estás apunto de recargar: S/ {{ payment.amount }}
          </h5>
          <h5>
            Forma de pago: {{ formPay.type }}
            <span v-if="formPay.card">
              - {{ formPay.card }}
            </span>
          </h5>
          <h4>
            ¿Estás seguro que es el monto correcto?
          </h4>
          <br>
          <p v-if="loading">
            <b-spinner small></b-spinner>
          </p>
          <div style="max-width: 420px; margin: auto;">
            <div class="row">
              <div class="col-6">
                <button
                  @click="closeModalConfirm()"
                  type="button"
                  class="btn btn-light btn-lg btn-block"
                >
                  Cancelar
                </button>
              </div>
              <div class="col-6">
                <button
                  @click="onPaymentSend()"
                  :disabled="loading"
                  type="button"
                  class="btn btn-action btn-lg btn-block"
                >
                  Confirmar
                </button>
              </div>
            </div>
          </div>
        </div>
      </b-modal>
      <b-modal
        v-model="modals.confirmReset"
        hide-header
        hide-footer
      >
        <div class="p-4">
          <h3 class="text-center">
            ¿Estás seguro que deseas salir de la pantalla de impresión?
          </h3>
          <br>
          <div style="max-width: 420px; margin: auto;">
            <div class="row">
              <div class="col-6">
                <button
                  @click="closeModalConfirmReset()"
                  type="button"
                  class="btn btn-primary btn-lg btn-block"
                >
                  Cancelar
                </button>
              </div>
              <div class="col-6">
                <button
                  @click="confirmResetData()"
                  type="button"
                  class="btn btn-action btn-lg btn-block"
                >
                  Salir
                </button>
            </div>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import api from '../api';

export default {
  data() {
    return {
      step: 1,
      loading: false,
      loadingUser: false,
      search: {
        type: 'code',
        value: '',
      },
      searchData: [],
      autocompleteInfo: false,
      userCode: null,
      userCodeValue: null,
      user: {
        id: '',
        code: '',
        points: 0,
        email: '',
        documentType: 'DNI',
        document: '',
        firstName: '',
        lastName: '',
      },
      formPay: {
        type: 'efectivo',
        card: null,
        code: null,
      },
      payment: {
        amount: '',
        cash: '',
      },
      transaction: {
        event: {},
        user: {},
        transactionDate: {},
        voucher: {},
        // ...
      },
      dateLocalPrint: '',
      dataToPrint: {
        type: 'Compra de puntos',
        productName: '',
        value: '',
        code: '',
      },
      modals: {
        confirm: false,
        confirmReset: false,
      },
      errors: {
        errorPayment: '',
        userNotFound: '',
      },
      isProductsCourtesy: false,
      loadingProducts: false,
      errorProducts: false,
      siteUrl: 'https://www.joinnus.com',
      event: {},
      showCamera: false,
      window: {
        width: 0,
        height: 0,
      },
    };
  },
  created() {
    this.getEventData();
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  computed: {
    dataPrint() {
      const { voucher, event } = this.transaction;
      const currEvent = event.currency === 'PEN' ? 'S/' : '$';
      return {
        title: this.event.title,
        date: this.dateLocalPrint,
        type: this.dataToPrint.type,
        productName: this.dataToPrint.productName,
        value: this.dataToPrint.value || this.user.points,
        code: this.dataToPrint.code || this.user.code,
        siteUrl: this.siteUrl,
        voucher,
        // eslint-disable-next-line
        currency: voucher ? (voucher.currency === 'PEN' ? 'S/' : '$') : currEvent,
      };
    },
    voucherMeta() {
      return {
        currency: this.transaction.voucher.currency === 'PEN' ? 'S/' : '$',
        method: this.formPay.type,
        methodCard: this.formPay.card,
        siteUrl: this.siteUrl,
      };
    },
    holderText() {
      let text = '';
      switch (this.search.type) {
        case 'email':
          text = 'Busca por email';
          break;
        case 'code':
          text = 'Busca por código QR';
          break;
        default:
          text = 'Busca por N° de documento';
          break;
      }
      return text;
    },
    onChangeCash() {
      const cashReturn = parseFloat(this.payment.cash) - parseFloat(this.payment.amount);
      return cashReturn ? (cashReturn).toFixed(2) : 0;
    },
  },
  methods: {
    async getEventData() {
      const { eventId } = this.$route.params;
      const { eventData } = await api.getDataEvent(eventId);
      this.event = eventData;
    },
    getDatePrint(date) {
      const d = date ? new Date(date) : new Date();
      return d.toLocaleString();
    },
    resetUser() {
      this.user = {
        id: '',
        code: '',
        points: 0,
        email: '',
        document: '',
        documentType: 'DNI',
        firstName: '',
        lastName: '',
      };
      this.userCode = null;
      this.userCodeValue = null;
    },
    setError(key) {
      setTimeout(() => {
        this.errors[key] = '';
      }, 5000);
    },
    goBack() {
      this.$router.push({ name: 'Home' });
    },
    goStep(step) {
      const self = this;
      this.step = step;
      if (step === 2) {
        setTimeout(() => {
          self.$refs.amount.focus();
        }, 300);
      }
    },
    closeModalConfirm() {
      this.modals.confirm = false;
    },
    closeModalConfirmReset() {
      this.modals.confirmReset = false;
    },
    onSearch() {
      const self = this;
      if (!this.search.value) return;
      const { value, type } = this.search;
      const { eventId } = this.$route.params;
      const { token } = this.$store.state.auth;
      const payload = {
        activityId: eventId,
        value,
        type,
        session: token,
      };
      this.loading = true;
      this.resetUser();
      api.axios.get('/wallet/points/search', { params: payload }).then((res) => {
        self.loading = false;
        if (res.data.success) {
          // res único
          if (res.data.data.users.code) {
            if (res.data.data.users.id) {
              self.onSelectUser(res.data.data.users);
              self.searchData = [];
            } else {
              self.onSelectUserQr(res.data.data.users);
            }
          } else if (res.data.data.users.length < 2) {
            if (res.data.data.users[0].id) {
              self.onSelectUser(res.data.data.users[0]);
              self.searchData = [];
            } else {
              self.onSelectUserQr(res.data.data.users[0]);
            }
          } else {
            self.searchData = res.data.data.users;
          }
        } else {
          if (self.search.type === 'email') {
            self.user.email = self.search.value;
          } else if (self.search.type === 'document') {
            self.user.document = self.search.value;
          }
          self.errors.userNotFound = 'Usuario no existe, registre nuevo o continua como invitado';
          self.setError('userNotFound');
          self.searchData = [];
        }
      }).catch(() => {
        self.loading = false;
        if (self.search.type === 'email') {
          self.user.email = self.search.value;
        } else if (self.search.type === 'document') {
          self.user.document = self.search.value;
        }
        self.errors.userNotFound = 'Error, intenta con otros datos, registre nuevo usuario o continua como invitado';
        self.setError('userNotFound');
        self.searchData = [];
      });
    },
    onSelectUserQr(user) {
      this.userCode = user.code;
      this.userCodeValue = user.points;
      this.user.document = user.dniUser;
      this.user = Object.assign({}, this.user, user);
    },
    onSelectUser(user) {
      if (user.id) {
        this.user.document = user.dniUser;
        this.user = Object.assign({}, this.user, user);
        this.autocompleteInfo = true;
        setTimeout(() => {
          this.autocompleteInfo = false;
        }, 5000);
      } else {
        this.onSelectUserQr(user);
        this.goStep(2);
      }
      this.searchData = [];
    },
    goQuest() {
      // this.resetUser();
      // this.user.email = '';
      // if (!this.user.document) return;
      this.goStep(2);
    },
    submitUser() {
      const self = this;
      this.loadingUser = true;
      const { token } = this.$store.state.auth;
      const { eventId } = this.$route.params;
      this.user.dniUser = this.user.document;
      const payload = Object.assign({}, this.user, {
        session: token,
        activityId: eventId,
      });
      api.axios.post('/user/register', payload).then((res) => {
        self.loadingUser = false;
        if (res.data.success) {
          self.user = res.data.data;
          self.user.document = res.data.data.dniUser;
          self.goStep(2);
        }
      }).catch(() => {
        self.loadingUser = false;
        self.errors.userNotFound = 'Error, intenta de nuevo.';
        self.setError('userNotFound');
      });
    },
    onPayment() {
      this.modals.confirm = true;
    },
    onPaymentSend() {
      const self = this;
      this.loading = true;
      const { token } = this.$store.state.auth;
      const { eventId } = this.$route.params;
      const payload = {
        eventId,
        userCode: this.userCode,
        user: {
          id: this.user.id,
          email: this.user.email,
          document: this.user.document,
          documentType: this.user.documentType,
          session: null,
        },
        sessionId: token, // usuario vendedor
        paymentMethod: this.formPay.type,
        paymentTransactionId: this.formPay.code,
        cardType: this.formPay.card,
        amount: this.payment.amount,
        methods: [
          {
            method: this.formPay.type,
            cardType: this.formPay.card,
            amount: this.payment.amount,
            paymentTransactionId: this.formPay.code,
            amountPayed: this.formPay.type !== 'efectivo' ? this.payment.amount : this.payment.cash,
            amountReturned: this.onChangeCash,
          },
        ],
        utmSource: 'punto-venta',
      };
      const jwtToken = this.signToken(payload);
      const url = `${api.checkoutUrl}/payment/points`;
      api.axios.post(url, { details: jwtToken }).then((res) => {
        self.loading = false;
        self.closeModalConfirm();
        if (!res.data.success) {
          const [msg] = res.data.message;
          self.errors.errorPayment = msg;
          self.setError('errorPayment');
          return;
        }
        self.goStep(3);
        self.transaction = res.data;
        self.dataToPrint.value = res.data.points;
        self.dataToPrint.code = res.data.qrCode;
      }).catch(() => {
        self.loading = false;
        self.closeModalConfirm();
        self.errors.errorPayment = 'Error, inténtalo de nuevo!';
        self.setError('errorPayment');
      });
    },
    printTransaction() {
      const self = this;
      if (!this.transaction.points) {
        // date local
        self.dateLocalPrint = self.getDatePrint();
      } else {
        // date transaction
        self.dateLocalPrint = self.getDatePrint(self.transaction.transactionDate.date);
      }
      setTimeout(() => {
        window.print();
      }, 200);
    },
    resetData() {
      this.modals.confirmReset = true;
    },
    confirmResetData() {
      this.closeModalConfirmReset();
      this.goStep(1);
      this.search = {
        type: 'code',
        value: '',
      };
      this.searchData = [];
      this.userCode = null;
      this.resetUser();
      this.formPay = {
        type: 'efectivo',
        card: null,
        code: null,
      };
      this.payment = {
        amount: '',
      };
      this.transaction = {
        event: {},
        user: {},
        transactionDate: {},
        voucher: {},
      };
      this.dataToPrint = {
        type: 'Compra de puntos',
        productName: '',
        value: '',
        code: '',
      };
      this.errors.errorPayment = '';
    },
    showProductsCourtesy() {
      if (!this.user.document) {
        this.errorProducts = true;
        setTimeout(() => {
          this.errorProducts = false;
        }, 5000);
        return;
      }
      const payload = `
      query {
        merchandiseCourtesies(activity: ${this.event.activity_id}) {
          providers {
            id
            firstName
            lastName
            email
            products {
              id
              name
              description
              images
              category {
                id
                name
              }
              currency {
                iso
                symbol
              }
              type
              sku
              price
              quantity
              quantitySold
              stock
            }
          }
        }
      }
      `;
      this.loadingProducts = true;
      api.graphqlAxios({
        method: 'post',
        data: {
          query: payload,
        },
      }).then((res) => {
        this.loadingProducts = false;
        const { providers } = res.data.data.merchandiseCourtesies;
        if (providers.length) {
          this.step = 0;
          this.isProductsCourtesy = true;
          this.$refs.appProductsCourtesy.init({
            event: this.event,
            user: this.user,
            providers,
          });
        }
      }).catch((err) => {
        // eslint-disable-next-line
        console.log(err);
        this.loadingProducts = false;
      });
    },
    successCortesy(args) {
      this.dataToPrint = {
        type: 'Cortesía',
        productName: args.productName,
        value: 0,
        code: args.data.code,
      };
      this.isProductsCourtesy = false;
      this.goStep(4);
    },
    printCourtesy() {
      this.dateLocalPrint = this.getDatePrint(); // date local
      setTimeout(() => {
        window.print();
      }, 200);
    },
    onDecode(result) {
      this.search.value = result;
      if (this.search.value) {
        this.onSearch();
      }
    },
    async onInit(promise) {
      try {
        await promise;
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          this.error = 'Error: Debe otorgar el permiso de acceso a la cámara';
        } else if (error.name === 'NotFoundError') {
          this.error = 'Error: No hay cámara en este dispositivo';
        } else if (error.name === 'NotSupportedError') {
          this.error = 'Error: Contexto seguro requerido (HTTPS, localhost)';
        } else if (error.name === 'NotReadableError') {
          this.error = 'Error: ¿La cámara ya está en uso?';
        } else if (error.name === 'OverconstrainedError') {
          this.error = 'Error: Las cámaras instaladas no son adecuadas';
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.error = 'Error: Stream API no es compatible con este navegador';
        } else if (error.name === 'TypeError') {
          this.error = 'Error: Tu navegador no soporta esta opción, actualízalo ó cambia de navegador';
        } else {
          this.error = `Error desconocido: ${error.message}`;
        }
      }
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
  },
};
</script>
<style lang="scss">
.title {
  font-size: 1.25rem;
  @media screen and (min-width: 48em) {
    font-size: 2rem;
  }
}
.subtitle {  
  font-size: 0.85rem !important;
  font-weight: 700 !important;
  @media screen and (min-width: 48em) {
    font-size: 1rem !important;
  }
}
.btn-dev {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  @media screen and (min-width: 48em) {
    flex-direction: row;
  }
  button {
    text-align: center;
    justify-content: center;
    align-items: center;
  }
}
.press {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  @media screen and (min-width: 48em) {
    flex-direction: row;
  }
}
.no-print {
  @media print {
    display: none;
  }
}
.table-center td {
  vertical-align: baseline !important;
  padding: 0.75rem 0 !important;
}
</style>